import React, { useEffect, useState } from "react";
import { reportsService } from "../api/services";
import { IAccessToken, Report } from "../models";
import { IPowerBiRefreshPermissionsResponse } from "../api/generated";

export interface ReportsContextProps {
    reportsAccessToken?: IAccessToken;
    report?: Report;
    getReport: (relativeUrl: string) => Promise<void>;
    getReportsAccessToken: () => Promise<void>;
    refreshPermissions: () => Promise<IPowerBiRefreshPermissionsResponse>;
};

export const ReportsContext = React.createContext({} as ReportsContextProps);

export const ReportsStore: React.FunctionComponent = props => {

    const [accessToken, setAccessToken] = useState<IAccessToken>();
    const [report, setReport] = useState<Report>();

    const onGetReportsAccessToken = async () => {
        const model = await reportsService.getReportsAuth();
        setAccessToken(model);
    };

    const onGetReport = async (relativeUrl: string) => {
        const model = await reportsService.getReport(relativeUrl);
        setReport(model);
    };

    const onRefreshPermissions = async () : Promise<IPowerBiRefreshPermissionsResponse> => {
        return await reportsService.refreshPermissions();
    }

    //TODO: Test access token refresh
    //TODO: What if ends up with 0 or <0?
    useEffect(() => {
        if (accessToken) {
            const intervalId = setInterval(onGetReportsAccessToken, accessToken.expiredSecondAfter * 1000);
            return () => clearInterval(intervalId);
        }
    }, [accessToken]);

    return (
        <ReportsContext.Provider value={
            { 
                reportsAccessToken: accessToken,
                report: report,
                getReport: onGetReport,
                getReportsAccessToken: onGetReportsAccessToken,
                refreshPermissions: onRefreshPermissions
            }}>
            {props.children}
        </ReportsContext.Provider>
    );
};
